import { render, staticRenderFns } from "./item-works.vue?vue&type=template&id=22f7e26f&"
import script from "./item-works.vue?vue&type=script&lang=js&"
export * from "./item-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports